<script setup lang="ts">
    // @ts-nocheck
    import KButton from "@/components/Button.vue";
    import KButtonGroup from "@/components/ButtonGroup.vue";

    const emit = defineEmits(["submit", "close"]);

    const close = () => {
        emit("close");
    };
</script>

<template>
    <div class="information-nll">
        <h3>Information om Nationella läkemedelslistan</h3>
        <div class="info-text">
            <p>
                Nationella läkemedelslistan innehåller patientens förskrivna läkemedel, andra förskrivna varor samt
                information om uttag på öppenvårdsapotek.
            </p>
            <div>
                <p>
                    För att få åtkomst till Nationella läkemedelslistan krävs att något av följande ändamål är
                    uppfyllda:
                </p>
                <ul>
                    <li>åstadkommande av en säker ordination av läkemedel och andra varor</li>
                    <li>beredande av vård eller behandling</li>
                    <li>komplettering av en patientjournal.</li>
                </ul>
                <p>
                    Vid åtkomst till en patients uppgifter i Nationella läkemedelslistan intygar du att något av
                    ändamålen är uppfyllda.
                </p>
            </div>
            <p>
                Patienten ska även ge sitt samtycke till åtkomsten. Om patienten saknar förmåga att ge samtycke ska det
                finnas giltiga skäl för att ändå få ta del av patientens läkemedelslista.
            </p>
            <p>All åtkomst loggas. Patienten har möjlighet att se i Läkemedelskollen vilka åtkomster som skett.</p>
        </div>
        <KButtonGroup>
            <KButton size="secondary" @click="close">Stäng</KButton>
        </KButtonGroup>
    </div>
</template>

<style lang="scss">
    .information-nll {
        h3 {
            margin-bottom: 1.5rem;
        }

        .info-text {
            display: flex;
            flex-direction: column;
            gap: 1.5rem;
            margin-bottom: 2.5rem;

            ul {
                padding-left: 1.25rem;
                margin-bottom: 1.25rem;

                li {
                    list-style-type: none;
                    position: relative;
                }

                li::before {
                    content: "•";
                    position: absolute;
                    left: -0.8rem;
                }
            }
        }
    }
</style>
